import {Component, NgZone, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {CreateUser} from './CreateUser';
import {DatePipe} from '@angular/common';

declare let $: any;

@Component({
  selector: 'account-setup',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css', '../app.component.css'],
  providers: [DatePipe]
})
export class AccountComponent implements OnInit {
  createAccountError = "";

  verifyCodeError = "";
  updatePasswordError = "";


  verifyAccnt = "";
  changeEmail = "";
  changeEmailConf= "";
  changePasswordOld = "";
  changePassword = "";
  changePasswordConf = "";




  constructor(public app: AppService, private zone: NgZone) {
  }

  ngOnInit() {
  }

  validateEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validatePassword(pass) {
    let re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
    return re.test(String(pass));
  }

  resendVerificationCode() {
    this.app.errorText = "Your verification code has been sent.";
    setTimeout(() => {
      alert("Your verification code has been sent.");
      // $('#errorModal').modal('show');
    }, 500);
    this.app.resendVerificationCode().subscribe((r) => {
      console.log("Verif code response: ", r);
    }, (error) => {
      console.log("Verif code error: ", error);
    });
  }

  verifyAccount() {
    if (this.verifyAccnt.length < 8) {
      this.verifyCodeError = "The code you entered isn't the required 8 characters long, please try again.";
      return;
    }
    this.app.verifyAccount(this.verifyAccnt).subscribe((r) => {
      console.log("Verify success: ", r);
      this.app.user.verified = true;
      $('#verifyAccountModal').modal('hide');
    }, (error) => {
      console.log("Verify error: ", error);
      this.verifyCodeError = "The code you entered was incorrect.";
    });
  }

  updateEmail() {
    if (!this.validateEmail(this.changeEmail)) {
      this.createAccountError = "Please enter a valid email address.";
      console.log("Invalid email address");
      return;
    }
    if (this.changeEmail !== this.changeEmailConf) {
      this.createAccountError = "The emails that you entered do not match.";
      return;
    }
    this.app.updateEmail(this.changeEmail).subscribe((data) => {
      console.log("Update email success: ", data);
      $('#updateAccountModal').modal('hide');
      this.app.user.email = this.changeEmail;
      this.changeEmail = "";
      this.changeEmailConf = "";
      this.createAccountError = "";
      this.app.errorText = "Email successfully changed.";
      $('#errorModal').modal('show');
    }, (error) => {
      console.log("Update email error: ", error);
      this.createAccountError = "The email address you entered is already used, please try another.";
      console.log("Invalid email address");
      return;
    });
  }

  updatePassword() {
    if (!this.validatePassword(this.changePassword)) {
      this.updatePasswordError = "The password you entered is not valid. The password must contain one lower case letter, one uppercase, one number, and be at least 8 characters.";
      return;
    }
    if (this.changePassword !== this.changePasswordConf) {
      this.updatePasswordError = "The passwords you entered do not match.";
      return;
    }
    if (this.changePassword !== this.changePasswordConf) {
      this.updatePasswordError = "The passwords you entered do not match.";
      return;
    }
    this.app.updatePassword(this.changePassword, this.changePasswordOld).subscribe((data) => {
      console.log("Update password success");
      $('#updateAccountModal').modal('hide');
      this.changePassword = "";
      this.changePasswordConf = "";
      this.changePasswordOld = "";
      this.updatePasswordError = "";
      this.app.errorText = "Password successfully changed.";
      $('#errorModal').modal('show');
    }, (error) => {
      console.log("Change Password error: ", error);
      this.updatePasswordError = "The password you entered does not match the old password, please try again.";
      return;
    });
  }

  cancelVerification() {
    this.app.clearUserID();
    location.reload();
  }
}
